// external
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { ICard, CardSize } from '@/interfaces/Card';
import { getRandomInt } from '@/utils/';
import {
    NEXT_CARD,
    GET_SIZE,
    GET_CARDS,
    GET_RANDOMIZE_CARDS_DISPLAYED,
} from '@/store/types';
import { VuexAction } from  '@/@types/index.d';

// components
import LargeCard from './components/large-card/LargeCard.vue';
import SmallCard from './components/small-card/SmallCard.vue';

@Component({
    components: {
        LargeCard,
        SmallCard,
    },
})
export default class CardCarousel extends Vue {
    @Getter(GET_SIZE) getSize!: CardSize;

    @Getter(GET_RANDOMIZE_CARDS_DISPLAYED) getRandomizeCardsDisplayed!: boolean;

    @Getter(GET_CARDS) getCards!: ICard[];

    @Action(NEXT_CARD) nextCard!: VuexAction<void>;

    get cardSize(): string {
        return this.getSize;
    }

    created() {
        // Randomize Cards
        if (this.getRandomizeCardsDisplayed && this.getCards.length) {
            const rand = getRandomInt(this.getCards.length);
            for (let i = 0; i < rand; i += 1) {
                this.nextCard();
            }
        }
    }
}
